/*
 * L'ancre par laquelle la popup d'ajout rapide délègue le guide des tailles à
 * la fiche produit : elle n'embarque plus son propre tiroir, elle envoie vers
 * `/products/x#guide-des-tailles` et c'est celui de la fiche qui s'ouvre.
 */
const SIZE_GUIDE_HASH = '#guide-des-tailles';

if (!customElements.get('size-guide-drawer')) {
  customElements.define(
    'size-guide-drawer',
    class SizeGuideDrawer extends HTMLElement {
      constructor() {
        super();
        this.lastTrigger = null;
        this.onKeydown = this.onKeydown.bind(this);
        this.close = this.close.bind(this);
      }

      connectedCallback() {
        const section = this.closest('product-info, [data-section]');
        const root = section || document;

        root.querySelectorAll('[data-size-guide-trigger]').forEach((trigger) => {
          const controls = trigger.getAttribute('aria-controls');
          if (controls && controls !== this.id) return;

          trigger.addEventListener('click', (event) => {
            event.preventDefault();
            this.lastTrigger = trigger;
            this.open();
          });
        });

        this.querySelector('[data-size-guide-close]')?.addEventListener('click', this.close);
        this.querySelector('[data-size-guide-overlay]')?.addEventListener('click', this.close);

        // Arrivée depuis la popup d'ajout rapide. Le `hashchange` couvre le cas
        // où le visiteur est déjà sur la fiche du produit : la navigation se
        // réduit alors à un changement d'ancre, sans rechargement, donc sans
        // second passage par connectedCallback.
        if (window.location.hash === SIZE_GUIDE_HASH) this.openFromHash();
        window.addEventListener('hashchange', () => {
          if (window.location.hash === SIZE_GUIDE_HASH) this.openFromHash();
        });
      }

      openFromHash() {
        if (this.dataset.state === 'open') return;
        this.lastTrigger = document.querySelector('[data-size-guide-trigger]');
        this.open();
      }

      open() {
        this.removeAttribute('hidden');
        // Force reflow so the transition plays from the initial state
        void this.offsetHeight;
        this.dataset.state = 'open';
        document.body.classList.add('overflow-hidden');
        document.addEventListener('keydown', this.onKeydown);
        if (this.lastTrigger) this.lastTrigger.setAttribute('aria-expanded', 'true');

        const panel = this.querySelector('.size-guide-drawer__panel');
        if (typeof trapFocus === 'function') {
          trapFocus(this, panel || this);
        } else {
          panel?.focus({ preventScroll: true });
        }
      }

      close() {
        delete this.dataset.state;
        document.body.classList.remove('overflow-hidden');
        document.removeEventListener('keydown', this.onKeydown);

        // Wait for the transition to finish before hiding so the slide-out plays
        setTimeout(() => {
          if (!this.dataset.state) this.setAttribute('hidden', '');
        }, 350);

        const trigger = this.lastTrigger;
        this.lastTrigger = null;
        if (trigger) trigger.setAttribute('aria-expanded', 'false');

        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(trigger);
        } else if (trigger) {
          trigger.focus({ preventScroll: true });
        }
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
        }
      }
    }
  );
}
